<template>
  <div class="container">
    <div class="mx-auto" style="width: 300px">
      <div class="custom-logo">
        <img src="https://invoicesainet.blob.core.windows.net/images/J_Logo_Black_256x256.png" alt="App" width="96" />
        <span class="custom-title">Invoices AI</span>
      </div>
      <div class="card">
        <h5 class="card-header text-center">Log In</h5>
        <div class="card-body">
          <FormLogin />
        </div>
      </div>
      <div class="text-center mt-4">
        <router-link to="/learn-more">learn more</router-link>
      </div>
    </div>
    <div class="text-center mt-5">
      <p>
        By using this service, you agree to our <router-link to="/terms-of-service">Terms of Service</router-link> and
        <router-link to="/privacy-policy">Privacy Policy</router-link>.
      </p>
      <p class="custom-copyright">© 2025 Jingle Enterprises. All rights reserved.</p>
    </div>
  </div>
</template>
<script>
import FormLogin from '@/components/auth/Login.vue'
export default {
  name: 'LoginView',
  components: {
    FormLogin
  }
}
</script>
<style lang="scss" scoped>
.custom-logo {
  width: 300px;
  text-align: center;
  margin-bottom: 20px;
}
.custom-title {
  position: relative;
  font-size: 1.8rem;
  font-weight: bold;
  font-style: italic;
  color: #333;
  top: 25px;
  left: 10px;
}
.custom-copyright {
  font-size: 0.8rem;
  color: #666;
  margin-top: 20px;
}
</style>
